<template>
  <v-container fluid ma-0 pa-0>
  <v-layout row v-if="customerHasCover">
      <v-flex :xs12="extendedMode" :xs7="!extendedMode">
        <div class="pagecontainer">
          <v-layout row class="mediumMargin layouttitletop">
            <v-flex xs10>
              <span class="header-title">{{labels.header}}</span>
            </v-flex>
             <v-flex xs2>
              <v-btn v-if="extendedMode && canCreateCover" color="primary"  @click="newCover" >{{labels.newResourceButtonLabel}} <span class="icon-plus"></span></v-btn>
            </v-flex>
          </v-layout>
          <v-layout row class="mediumMargin">
            <v-flex class="filterBox">
              <div class="inlinebox align-center">
                <SearchBuyerInputField @search="searchCovers" v-model="coverFilter" :hasError.sync="coverFilter.companyIdHasError"/>
                <div class="inlinebox align-center ml-2">
                  <span class="icon-cover ml-0" style="color: var(--primary-color)"></span>
                  <v-text-field ref="coverIdInputBox" v-model="coverFilter.coverId" :rules="validationRules.coverId" placeholder="Cover Id" class="searchbuyerinput" clearable @keydown.enter="searchCovers" @click:clear="clearCoverIdFilter" @update:error="coverIdErrorChanged"></v-text-field>
                </div>
                <v-btn color="primary" outline class="align-center ml-2" @click="searchCovers" :disabled="!canSearchCovers">Search <span class="icon-search"></span></v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row class="mediumMargin">
            <ul class="tabs group">
              <li v-for="tab in tabs" :key="tab.key">
                <router-link :to="{ path: tab.route }" v-bind:class="{'activetab':(tab.route === activeTab)}"> {{ $t(tab.name) }}
                    <span class="covernumbers">
                        {{ tab.totalCoversCount }}
                    </span>
                </router-link>
              </li>
          </ul>
          </v-layout>
        </div>
        <v-layout row>
          <router-view></router-view>
        </v-layout>
      </v-flex>
      <v-flex v-show="!extendedMode" xs5 shrink>
          <CoverInfo v-show="!extendedMode" ref="coverinfo"/>
      </v-flex>
    </v-layout>
    <v-layout v-if="!customerHasCover" row>
      <EmptyStatePlaceHolder :header="labels.header" :description="labels.emptyStateDescription" :newResourceButtonLabel="labels.newResourceButtonLabel" :canCreateResource="canCreateCover" @createNewResource="newCover"/>
    </v-layout>
    <NewCover ref="newCoverForm" :coverTransferredFromList="coverTransferredFromList" :defaultCurrency="currentCurrency" :currencies="currencyFlags" @refreshContent="refreshContent" @successfulCoverTransferOnDispose="successfulCoverTransferOnDispose" @refreshUpdatedCoverInformationInList="refreshUpdatedCoverInformationInList"/>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import coverApi from '@/services/CoverApi'
import constants from '@/constants/index'
import auth from '@/services/Auth'
import CoverInfo from '@/components/cover/details/CoverInfo'
import NewCover from '@/components/cover/newcover/NewCover'
import dayjs from 'dayjs'
import EmptyStatePlaceHolder from '@/components/EmptyStatePlaceholder.vue'
import accountApi from '@/services/AccountApi'
import { sumFloat } from '@/services/Utils'
import SearchBuyerInputField from '@/components/common/SearchBuyerInputField.vue'
export default {
  data () {
    return {
      labels: {
        header: this.$t('Cover.ListCover.INVOICE_OVERVIEW_TITLE'),
        emptyStateDescription: this.$t('Cover.ListCover.NO_COVERS_DESC'),
        newResourceButtonLabel: this.$t('Cover.ListCover.NEW_COVER_LINK')
      },
      activeTab: '/',
      autoRefreshTimerForAssessingCovers: null,
      intervalGetAllAssessingCovers: 180000,
      intervalGetCover: 2000,
      settleCoverSuccessText: this.$t('Cover.ListCover.COVER_SETTLED_DESC'),
      settleCoverFailedText: this.$t('Cover.ListCover.CANNOT_SETTLE_COVER_DESC'),
      assessingCoverQuotedText: this.$t('Cover.ListCover.ASSESSED_AND_QUOTED_INVOICE_DESC'),
      assessingCoverRejectedText: this.$t('Cover.ListCover.ASSESSED_AND_REFUSED_INVOICE_DESC'),
      coverTransferredFromList: null,
      isUserThatCanUpdateCovers: false,
      emptyClaim: {
        status: '',
        documents: [],
        owner: {},
        claimContextInfo: {},
        buyerContact: {},
        sellerContact: {}
      },
      coverFilter: {
        identifierCountryCode: '',
        identifierTypeCode: '',
        identifierValue: '',
        coverId: '',
        companyIdHasError: false,
        coverIdHasError: false
      },
      coverCountPerStatus: []
    }
  },
  async mounted () {
    this.coverCountPerStatus = await coverApi.getCustomerInvoiceCoverCount()
    await this.setCoverTabCount()
    let policySettings = await accountApi.getPolicySettings()
    this.isUserThatCanUpdateCovers = policySettings && policySettings[0].isUserThatCanUpdateCovers
    if (this.customerHasCover) {
      this.activeTab = this.$router.currentRoute.path
    }
    this.autoRefreshTimerForAssessingCovers = window.setInterval(this.autoRefreshAssessingCovers, this.intervalGetAllAssessingCovers)
  },
  beforeDestroy () {
    this.cancelAssessingCoversAutoUpdate()
  },
  watch: {
    '$route' (to, from) {
      if (!this.extendedMode) {
        this.$refs.coverinfo.initializeAndCloseExtendedMode()
      }
      this.activeTab = this.$router.currentRoute.path
    }
  },
  methods: {
    sumFloat,
    clearCoverIdFilter () {
      this.coverFilter.coverId = ''
      this.coverFilter.coverIdHasError = false
      this.searchCovers()
    },
    coverIdErrorChanged (val) {
      this.coverFilter.coverIdHasError = val
    },
    async autoRefreshAssessingCovers () {
      var assessingCovers = await coverApi.fetchCoversbyStatusPerPage(1, 10, 'Assessing', 'quotedAt', null, null, 'quotedAt', 'desc', null)
      if (assessingCovers) {
        assessingCovers.items.forEach(async (cover, index) => {
          await this.$sleep(this.intervalGetCover * (index + 1))
          await this.getAssessingCover(cover)
        })
      }
    },
    async getAssessingCover (cover) {
      var coverDetails = await coverApi.getCoverDetails(cover.id)
      if (coverDetails && coverDetails.status.toLowerCase() !== cover.status.toLowerCase()) {
        switch (coverDetails.status.toLowerCase()) {
          case constants.CoverStatus.PENDING.toLowerCase(): {
            this.setCoverPending(coverDetails)
            break
          }
          case constants.CoverStatus.REJECTED.toLowerCase(): {
            await this.setRejectedCover(coverDetails)
            break
          }
        }
      }
    },
    setCoverPending (cover) {
      if (this.activeTab === '/quoted') {
        var coverIndex = this.quotedCovers.findIndex(x => x.id === cover.id)
        if (coverIndex >= 0) {
          this.quotedCovers[coverIndex].status = this.coverStatus.findIndex(x => x.name === cover.status) >= 0 ? this.coverStatus.find(x => x.name === cover.status).label : cover.status
          this.quotedCovers[coverIndex].statusCode = cover.status
          this.quotedCovers[coverIndex].isRemaining = cover.status.toLowerCase() === constants.CoverStatus.PENDING.toLowerCase() && dayjs(cover.coverage.ValidUntil).add(1, 'days').diff(dayjs(), 'days') <= this.nbRemainingDaysForQuotedCover
          this.quotedCovers[coverIndex].daysRemaining = dayjs(cover.coverage.ValidUntil).startOf('day').add(1, 'days').diff(dayjs().startOf('day'), 'days')
        }
      }
      this.$store.dispatch('global/setSnackbarSuccess', this.assessingCoverQuotedText)
    },
    async setRejectedCover (cover) {
      if (this.activeTab === '/quoted') {
        var coverIndex = this.quotedCovers.findIndex(x => x.id === cover.id)
        if (coverIndex >= 0) {
          await this.$store.dispatch('coverquoted/getCoversQuoted', { coverStatusLabels: this.coverStatus })
        }
      }
      this.$store.dispatch('global/setSnackbarFailed', this.assessingCoverRejectedText)
    },
    cancelAssessingCoversAutoUpdate () {
      window.clearInterval(this.autoRefreshTimerForAssessingCovers)
    },
    async showCoverInfoDetail (coverid, isClaimable, originTab, createClaim) {
      let cover = {}
      let coverDetail = await coverApi.getCoverDetails(coverid)
      let sellerbuyer = [coverDetail.sellerId, coverDetail.buyerId]
      let companies = await coverApi.fetchCompaniesId(sellerbuyer)
      let seller = companies.items.find(function (company) {
        return company.id === coverDetail.sellerId
      })

      let buyer = companies.items.find(function (company) {
        return company.id === coverDetail.buyerId
      })

      this.canbeClaimed = isClaimable

      let coverDetailPricingIsAvailable = !!coverDetail.coverage.coverPrice
      let coverDetailCurrency = coverDetailPricingIsAvailable ? coverDetail.coverage.currency.toUpperCase() : ''
      cover.rejectionReason = coverDetail.rejectionReason
      cover.invoice = {
        status: originTab === 'Late' ? 'Late' : this.coverStatus.findIndex(x => x.name === coverDetail.status) >= 0 ? this.coverStatus.find(x => x.name === coverDetail.status).label : this.$toTitleCase(coverDetail.status),
        statusCode: originTab === 'Late' ? 'Late' : coverDetail.status,
        amount: coverDetail.invoice.Amount + ' ' + coverDetail.invoice.Currency.toUpperCase(),
        currency: coverDetail.invoice.Currency.toUpperCase(),
        number: coverDetail.invoice.Number,
        issuedAt: this.$formatDate(coverDetail.invoice.IssuedAt),
        dueAt: this.$formatDate(coverDetail.invoice.DueAt),
        isTooLate: (coverDetail.status === 'Activated' || coverDetail.status === 'Defaulted') && dayjs().startOf('day').isAfter(dayjs(coverDetail.claimLimitAt).add(-5, 'days')),
        tooLateDescription: `${(dayjs(coverDetail.claimLimitAt)).diff(dayjs().startOf('day'), 'days') + 1} days left to claim`,
        daysLate: dayjs(new Date()).diff(dayjs(coverDetail.invoice.DueAt).add(1, 'days'), 'days'),
        isDueDatePassed: dayjs().startOf('day').isAfter(coverDetail.invoice.DueAt),
        seller: seller,
        buyer: buyer,
        fundedAmount: coverDetail.fundedAmount ? coverDetail.fundedAmount.toFixed(2) + ' ' + coverDetailCurrency : '',
        fundedAmountValue: coverDetail.fundedAmount
      }
      let daysRemaining = dayjs(coverDetail.coverage.ValidUntil).startOf('day').add(1, 'days').diff(dayjs().startOf('day'), 'days')
      cover.details = {
        id: coverDetail.id,
        activatedAt: this.$formatDate(coverDetail.coverage.activatedAt),
        quotedAt: this.$formatDate(coverDetail.coverage.quotedAt),
        settledAt: this.$formatDate(coverDetail.coverage.SettledAt),
        duration: coverDetail.coverage.duration ? coverDetail.coverage.duration : '',
        totalCoverPrice: coverDetailPricingIsAvailable ? (coverDetail.coverage.coverPrice + ' ' + coverDetailCurrency) : '',
        originTab: originTab,
        validUntil: this.$formatDate(coverDetail.coverage.ValidUntil),
        isRemaining: daysRemaining <= this.nbRemainingDays,
        daysRemaining: daysRemaining
      }
      let totalServiceFee = sumFloat(coverDetail.coverage.serviceFee, coverDetail.coverage.serviceFeeVatAmount)
      let totalCollectionFee = sumFloat(coverDetail.coverage.collectionFeeAmount, coverDetail.coverage.collectionFeeVatAmount)
      let totalTechnicalFee = sumFloat(coverDetail.coverage.technicalFeeAmount, coverDetail.coverage.technicalFeeVatAmount)
      if (coverDetailPricingIsAvailable) {
        cover.price = {
          insurancePremiumAmount: coverDetail.coverage.insurancePremiumAmount,
          totalServiceFee: !!coverDetail.coverage.collectionFeeAmount ? totalServiceFee + ' ' + coverDetailCurrency : '',
          serviceFeeAmount: coverDetail.coverage.serviceFee ? coverDetail.coverage.serviceFee + ' ' + coverDetailCurrency : '',
          serviceFeeVatAmount: coverDetail.coverage.serviceFeeVatAmount ? coverDetail.coverage.serviceFeeVatAmount + ' ' + coverDetailCurrency : '',
          serviceFeeRate: coverDetail.coverage.serviceFeeRate ? (coverDetail.coverage.serviceFeeRate * 100) + '%' : '',
          serviceFeeVatRate: coverDetail.coverage.serviceFeeVatRate ? (coverDetail.coverage.serviceFeeVatRate * 100) + '%' : '',
          totalCollectionFee: !!coverDetail.coverage.collectionFeeAmount ? totalCollectionFee + ' ' + coverDetailCurrency : '',
          collectionFeeAmount: coverDetail.coverage.collectionFeeAmount ? coverDetail.coverage.collectionFeeAmount + ' ' + coverDetailCurrency : '',
          collectionFeeVatAmount: coverDetail.coverage.collectionFeeVatAmount ? coverDetail.coverage.collectionFeeVatAmount + ' ' + coverDetailCurrency : '',
          collectionFeeRate: coverDetail.coverage.collectionFeeRate ? (coverDetail.coverage.collectionFeeRate * 100) + '%' : '',
          collectionFeeVatRate: coverDetail.coverage.collectionFeeVatRate ? (coverDetail.coverage.collectionFeeVatRate * 100) + '%' : '',
          insuranceTaxAmount: coverDetail.coverage.insuranceTaxAmount ? coverDetail.coverage.insuranceTaxAmount + ' ' + coverDetailCurrency : '',
          insuranceTaxRate: coverDetail.coverage.insuranceTaxRate ? (coverDetail.coverage.insuranceTaxRate * 100) + '%' : '',
          technicalFeeAmount: coverDetail.coverage.technicalFeeAmount ? coverDetail.coverage.technicalFeeAmount + ' ' + coverDetailCurrency : '',
          technicalFeeRate: coverDetail.coverage.technicalFeeRate ? (coverDetail.coverage.technicalFeeRate * 100) + '%' : '',
          technicalFeeVatAmount: coverDetail.coverage.technicalFeeVatAmount ? coverDetail.coverage.technicalFeeVatAmount + ' ' + coverDetailCurrency : '',
          technicalFeeVatRate: coverDetail.coverage.technicalFeeVatRate ? (coverDetail.coverage.technicalFeeVatRate * 100) + '%' : '',
          totalTechnicalFee: !!coverDetail.coverage.technicalFeeAmount ? totalTechnicalFee + ' ' + coverDetailCurrency : ''
        }
      } else {
        cover.price = {}
      }
      if (coverDetail.status === 'Claimed') {
        this.isClaimed = true
        cover.claim = coverDetail.Claim === undefined ? this.emptyClaim : {
          id: coverDetail.Claim.ClaimId,
          status: this.claimStatus.findIndex(x => x.name === coverDetail.Claim.ClaimStatus) >= 0 ? this.claimStatus.find(x => x.name === coverDetail.Claim.ClaimStatus).label : this.$toTitleCase(coverDetail.Claim.ClaimStatus),
          number: coverDetail.Claim.ExternalId,
          buyerContact: {
            firstName: coverDetail.Claim.Debtor.ContactInformation.FirstName,
            lastName: coverDetail.Claim.Debtor.ContactInformation.LastName,
            email: coverDetail.Claim.Debtor.ContactInformation.Email,
            mobilePhone: coverDetail.Claim.Debtor.ContactInformation.MobilePhone,
            officePhone: coverDetail.Claim.Debtor.ContactInformation.OfficePhone
          },
          sellerContact: {
            firstName: coverDetail.Claim.Creditor.ContactInformation.FirstName,
            lastName: coverDetail.Claim.Creditor.ContactInformation.LastName,
            email: coverDetail.Claim.Creditor.ContactInformation.Email,
            mobilePhone: coverDetail.Claim.Creditor.ContactInformation.MobilePhone,
            officePhone: coverDetail.Claim.Creditor.ContactInformation.OfficePhone
          },
          documents: this.userInfos.claimSettings.documentFileTypes.map((d) => {
            return {
              fileType: d.fileType,
              fileTitle: this.$t(this.$getFileTypeLabel(d.fileType, this.userInfos.country)),
              files: coverDetail.Claim.Invoice.Evidences.filter(c => c.DocumentType.toUpperCase() === d.fileType.toUpperCase()).map((file) => {
                return {
                  id: file.Id,
                  fileName: file.FileName
                }
              })
            }
          }),
          createdAt: this.$formatDate(coverDetail.Claim.CreatedAt),
          owner: {
            firstName: coverDetail.Claim.Owner.FirstName,
            lastName: coverDetail.Claim.Owner.LastName,
            initials: coverDetail.Claim.Owner.FirstName.charAt(0) + '' + coverDetail.Claim.Owner.LastName.charAt(0),
            calculatedColor: this.$strToColor(coverDetail.Claim.Owner.LastName + ' ' + coverDetail.Claim.Owner.FirstName)
          },
          claimContextInfo: {
            clientReferenceNumber: coverDetail.Claim.ReferenceNumber,
            isDisputed: coverDetail.Claim.IsInvoiceDisputed === true ? 'Yes' : coverDetail.Claim.IsInvoiceDisputed === false ? 'No' : '',
            isInsolvencyProceeding: coverDetail.Claim.IsInsolvencyProceeding === true ? 'Yes' : coverDetail.Claim.IsInsolvencyProceeding === false ? 'No' : '',
            comment: coverDetail.Claim.Comment,
            collectedAmount: coverDetail.Claim.CollectedAmount ? coverDetail.Claim.CollectedAmount.toFixed(2) + ' ' + coverDetailCurrency : '',
            amountWithoutVAT: coverDetail.Claim.AmountWithoutVAT ? coverDetail.Claim.AmountWithoutVAT.toFixed(2) + ' ' + coverDetailCurrency : '',
            deliveryDate: coverDetail.Claim.DeliveryDate ? this.$formatDate(coverDetail.Claim.DeliveryDate) : null
          }
        }
      }

      this.$store.dispatch('cover/setCoverDetails', cover)
      if (!this.extendedMode) {
        if (createClaim) {
          this.$refs.coverinfo.initializeCreateClaim()
        } else {
          this.$refs.coverinfo.initialize()
        }
      }
    },
    setHeightForSideInfo () {
      let heightToSet = $(window).height() - 47
      $('#coverinfocontainer').css('height', heightToSet + 'px')
    },
    newCover () {
      this.$store.dispatch('newcover/setDefaultCountryForSearchCompany', this.userInfos.country)
      this.$refs.newCoverForm.initValues()
      this.$store.dispatch('cover/setCreateNewCoverDialog', true)
    },
    successfulCoverTransferOnDispose () {
      this.coverTransferredFromList = null
    },
    refreshUpdatedCoverInformationInList (updatedCover) {
      var coverInList = this.quotedCovers.find(c => c.id === updatedCover.id)
      if (coverInList) {
        coverInList.amount = updatedCover.invoice.invoiceValue + ' ' + updatedCover.invoice.currency
        coverInList.dueAt = updatedCover.invoice.dueDate
        coverInList.issuedAt = updatedCover.invoice.issueDate
      }
    },
    async openUpdateCover (coverId) {
      let coverDetail = await coverApi.getCoverDetails(coverId)
      let sellerbuyer = [coverDetail.sellerId, coverDetail.buyerId]
      let resultcompanies = await coverApi.fetchCompaniesId(sellerbuyer)
      let companies = resultcompanies.items.map((item) => {
        return {
          isFinal: true,
          id: item.id,
          ehId: item.ehId,
          name: item.name,
          mainIdentifierCode: item.identifierType,
          mainIdentifierValue: item.identifierValue,
          streetNumber: item.address.streetNumber,
          streetName: item.address.streetName,
          postCode: item.address.postCode,
          city: item.address.city,
          country: item.address.country
        }
      })
      this.coverTransferredFromList = { id: coverId }
      this.coverTransferredFromList.seller = companies.find(function (company) {
        return company.id === coverDetail.sellerId
      })
      this.coverTransferredFromList.buyer = companies.find(function (company) {
        return company.id === coverDetail.buyerId
      })
      this.coverTransferredFromList.invoice = coverDetail.invoice
      this.coverTransferredFromList.invoice.IssuedAt = this.$formatDate(this.coverTransferredFromList.invoice.IssuedAt)
      this.coverTransferredFromList.invoice.DueAt = this.$formatDate(this.coverTransferredFromList.invoice.DueAt)
      this.newCover()
    },
    async refreshContent () {
      this.coverCountPerStatus = await coverApi.getCustomerInvoiceCoverCount()
      await this.setCoverTabCount()
      this.activeTab = this.$router.currentRoute.path
    },
    hasCoverageAccess () {
      return auth.hasCoverageAccess()
    },
    async settleCover (coverid) {
      let settledAt = dayjs().add(-1, 'minutes').format()
      let success = await coverApi.settleCover(coverid, settledAt)
      if (success) {
        this.$store.dispatch('global/setSnackbarSuccess', this.settleCoverSuccessText)
        await this.setCoverTabCount()
      } else {
        this.$store.dispatch('global/setSnackbarFailed', this.settleCoverFailedText)
      }

      return success
    },
    searchCovers () {
      if (this.canSearchCovers) {
        this.$store.dispatch('listcovertabs/setFilters', {
          identifierValue: !!this.coverFilter.identifierValue ? this.coverFilter.identifierValue : '',
          identifierTypeCode: this.coverFilter.identifierTypeCode,
          identifierCountryCode: this.coverFilter.identifierCountryCode,
          coverId: this.coverFilter.coverId })
      }
    },
    toInt (value) {
      let parsed = parseInt(value, 10)
      if (isNaN(parsed) || !parsed) {
        return 0
      }
      return parsed
    },
    setCoverTabCount: async function () {
      this.$store.dispatch('listcovertabs/setCoversTabCountByKey', { key: 'coversquoted', totalCount: this.toInt(this.coverCountPerStatus['Quoted']) + this.toInt(this.coverCountPerStatus['Assessing']) })
      this.$store.dispatch('listcovertabs/setCoversTabCountByKey', { key: 'coversactivated', totalCount: this.toInt(this.coverCountPerStatus['Activated']) })
      this.$store.dispatch('listcovertabs/setCoversTabCountByKey', { key: 'coverssettled', totalCount: this.toInt(this.coverCountPerStatus['Settled']) })
      this.$store.dispatch('listcovertabs/setCoversTabCountByKey', { key: 'coversclaimed', totalCount: this.toInt(this.coverCountPerStatus['Claimed']) })
      this.$store.dispatch('listcovertabs/setCoversTabCountByKey', { key: 'coversarchived', totalCount: this.toInt(this.coverCountPerStatus['TimeBarred']) + this.toInt(this.coverCountPerStatus['Rejected']) + this.toInt(this.coverCountPerStatus['Refused']) + this.toInt(this.coverCountPerStatus['Revoked']) })
      this.$store.dispatch('listcovertabs/setCoversTabCountByKey', { key: 'coverstimebarred', totalCount: this.toInt(this.coverCountPerStatus['TimeBarred']) })
      await this.$store.dispatch('listcovertabs/updateCoversLateCount')
    }
  },
  computed: {
    ...mapState('cover', ['extendedMode', 'coverStatus', 'claimStatus', 'documentType']),
    ...mapState('listcovertabs', ['tabs', 'filters']),
    ...mapState('userdetails', ['userInfos']),
    ...mapState('countries', ['currencyFlags']),
    ...mapState('coverquoted', ['nbRemainingDays']),
    ...mapState('siteconfig', ['config']),
    ...mapGetters({
      quotedCovers: 'coverquoted/covers',
      nbRemainingDaysForQuotedCover: 'coverquoted/nbRemainingDays'
    }),
    canCreateCover: function () {
      if (!this.config && !this.userInfos.country) {
        return false
      }

      let allowedCountries = this.config.newCoverAllowedCountries.toUpperCase().split(',')
      return auth.hasCoverageAccess() && allowedCountries.includes(this.userInfos.country.toUpperCase())
    },
    currentCurrency: function () {
      let country = this.userInfos.country ? this.userInfos.country : 'FR'
      return this.currencyFlags.find(f => f.countriesCode.includes(country.toUpperCase()))
    },
    validationRules: function () {
      return constants.VALIDATION_RULES
    },
    canSearchCovers: function () {
      return !this.coverFilter.companyIdHasError && !this.coverFilter.coverIdHasError
    },
    customerHasCover: function () {
      return this.coverCountPerStatus === undefined ||
      (!!this.coverCountPerStatus['Total'] && this.coverCountPerStatus['Total'] > 0) ||
        this.coverCountPerStatus > 0 // retro compatibility
    }
  },
  components: {
    SearchBuyerInputField,
    CoverInfo,
    EmptyStatePlaceHolder,
    NewCover
  }

}
</script>
<style>
.coverdetails {
  margin-top: 400px
}

.v-window__container--is-active {
    overflow: inherit;
}

.tabs {
  list-style: none;
  padding-left: 0px;
  margin-left: -11px;
}
.tabs li { display: inline; }
.tabs li a {
  float: left;
  display: flex;
  padding: 4px 12px;
  margin-left: -1px;
  position: relative;
  left: 1px;
  text-decoration: none;
  font-size: 15.0px;
  color: rgba(42, 42, 42, 1.0);
  text-align: left;
  line-height: 16.0px;
  border-bottom: solid;
  border-bottom-width: 2px;
  padding-bottom: 4px;
  border-color: transparent;
}
.tabs li a:hover {
  color: var(--primary-color);
  border-bottom: solid;
  border-bottom-width: 2px;
  padding-bottom: 4px;
}

.activetab {
  border-bottom: solid;
  border-bottom-width: 2px;
  color: var(--primary-color) !important;
  border-bottom-color: var(--primary-color) !important;
}
.mediumMargin {
  margin-bottom: 16px;
}

.tablerow{
  padding-right: 84px;
}

.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.filterBox {
  background-color: var(--primary-color-lighten);
  overflow: hidden;
}

</style>
